/**
 * Snapmint EMI widget — kept off the critical path.
 *
 * The vendor bundle is ~102KB transferred and was previously loaded with `defer`
 * on every product page, so it downloaded and compiled while the browser was
 * still working on first paint. Nothing about the widget is needed that early:
 * it renders an EMI line into #snapmint-anchor and is only actionable once the
 * shopper reaches the price area.
 *
 * It now loads at whichever comes first:
 *   1. the shopper's first interaction with the page, or
 *   2. an idle moment after the load event.
 *
 * (2) is the guarantee — the EMI line always appears, even for a shopper who
 * never scrolls or taps, so this is a timing change and not a feature gate.
 */
(function () {
  var loader = document.currentScript;
  var src = loader && loader.dataset.snapmintSrc;
  if (!src) return;

  var INTERACTIONS = ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'];
  var injected = false;

  function inject() {
    if (injected) return;
    injected = true;

    INTERACTIONS.forEach(function (evt) {
      window.removeEventListener(evt, inject, { passive: true });
    });

    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
  }

  INTERACTIONS.forEach(function (evt) {
    window.addEventListener(evt, inject, { passive: true, once: true });
  });

  function scheduleFallback() {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(inject, { timeout: 3000 });
    } else {
      window.setTimeout(inject, 1500);
    }
  }

  if (document.readyState === 'complete') {
    scheduleFallback();
  } else {
    window.addEventListener('load', scheduleFallback, { once: true });
  }
})();
